export enum STATUS_CODE {
  NORMAL = 200,
  BAD_REQUEST = 400,
  AUTHENTICATION_ERROR = 401,
  NOT_FOUND = 404,
  PERMISSION_ERROR = 403,
  ERROR = 500,
  COMMUNICATION_ERROR = 502,
  NETWORK_ERROR = 0, // Network connectivity issues (no response from server)
}
